import { createContext, forwardRef, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayOptimizedContext = /*#__PURE__*/createContext({
  isDisplayOptimized: false
});
export const DisplayOptimizedProvider = ({
  children,
  value
}) => {
  const contextValue = useMemo(() => ({
    isDisplayOptimized: value
  }), [value]);
  return /*#__PURE__*/_jsx(DisplayOptimizedContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useIsDisplayOptimized = () => {
  const {
    isDisplayOptimized
  } = useContext(DisplayOptimizedContext);
  return isDisplayOptimized !== null && isDisplayOptimized !== void 0 ? isDisplayOptimized : false;
};
export const withDisplayOptimized = WrappedComponent => {
  const WithDisplayOptimized = /*#__PURE__*/forwardRef((props, ref) => {
    const isDisplayOptimized = useIsDisplayOptimized();
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      isDisplayOptimized: isDisplayOptimized,
      ref: ref
    }));
  });
  WithDisplayOptimized.displayName = `withDisplayOptimized(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithDisplayOptimized;
};